import React, { useEffect, useState } from "react";
import axiosConfig from "../../axiosConfig";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import { tableIcons } from "../../shared/TableIcons";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";
import authgetUser from "../../services/auth.getUser";
import jwt_decode from "jwt-decode";
import { swalSubmit } from "../../shared/swalSubmit";

const useStyles = makeStyles(styles);

function EndUsers() {
  const [users, setUsers] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    refreshList();
  }, []);

  const refreshList = () => {
    axiosConfig
      .get("/Beneficiary")
      .then((res) => {
        setUsers(res.data);
        setisLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDeleteClick = (selected) => {
    axiosConfig
      .delete(`/Beneficiary/${selected}`, {})
      .then((res) => {
        if (res.status === 200) {
          refreshList();
          Swal.fire("Η καταχώρηση ήταν επιτυχής", "", "success");
        } else {
          Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
        }
      })
      .catch((err) => {
        Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
      });
  };

  const getTheUser = authgetUser();
  const decodedToken = jwt_decode(getTheUser.accessToken);
  const roleDescription = decodedToken.role;

  return (
    <Grid item xs={12} style={{ marginTop: "16px" }}>
      <Card>
        <CardHeader color="warning">
          <h1 className={classes.cardTitleWhite}>Ωφελούμενοι</h1>
        </CardHeader>
        <CardBody>
          <MaterialTable
            icons={tableIcons}
            title=""
            isLoading={isLoading}
            columns={[
              {
                title: "Κωδικός Ωφελούμενου",
                field: "id",
                cellStyle: {
                  width: 20,
                  maxWidth: 20,
                },
                headerStyle: {
                  width: 20,
                  maxWidth: 20,
                },
              },
              {
                title: "Επώνυμο",
                field: "lastname",
                cellStyle: {
                  width: 20,
                  maxWidth: 20,
                },
                headerStyle: {
                  width: 20,
                  maxWidth: 20,
                },
              },
              {
                title: "Όνομα",
                field: "firstname",
                cellStyle: {
                  width: 20,
                  maxWidth: 20,
                },
                headerStyle: {
                  width: 20,
                  maxWidth: 20,
                },
              },
              {
                title: "Πατρώνυμο",
                field: "middlename",
                cellStyle: {
                  width: 20,
                  maxWidth: 20,
                      
                },
                headerStyle: {
                  width: 20,
                  maxWidth: 20,
                }
              }
            ]}
            data={users}
            actions={[
              {
                icon: () => <AddBox />,
                onClick: () => {
                  history.push("/add-end-user");
                },
                isFreeAction: true,
                tooltip: "Προσθήκη",
              },
              {
                icon: () => <DevicesOtherIcon />,
                tooltip: "Επεξεργασία Συσκευής",
                onClick: (e, row) => {
                  {row.devices[0] &&  history.push({
                    pathname: "/smart-band-values",
                    selected: row.devices[0].id,
                    locationPath: "EndUsers",
                  });}
                 
                },
              },

              {
                icon: () => <Edit />,
                tooltip: "Επεξεργασία/Λεπτομέρειες",
                onClick: (e, row) => {
                  history.push({
                    pathname: "/edit-end-user",
                    selected: row.id,
                  });
                },
              },
              roleDescription==="Admin"?{
                icon: () => <DeleteOutline />,
                tooltip: "Απενεργοποίηση",
                onClick: (e, row) => {
                  Swal.fire({
                    title: "",
                    text: `Έχετε επιλέξει να απενεργοποιήσετε τον Ωφελούμενο με Κωδικό ${row.id}.Με την απενεργοποίηση αυτή θα αποδεσμευτούν οι συσκευές που έχουν συνδεθεί στον κωδικό αυτόν και θα επιστρέψουν στις αρχικές ρυθμίσεις.Η Απενεργοποίηση Ωφελούμενου θα είναι οριστική. Είστε βέβαιοι;`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Ναι",
                    cancelButtonText: "Οχι",
                  }).then((result) => {
                    if(result.isConfirmed) {
                      Swal.fire(swalSubmit).then((result) => {
                        if(result.isConfirmed){
                          handleDeleteClick(row.id);
                        } else{
                          history.push('/end-user')
                        }
                      })
                    }
                  })
                },
              }:null,
            ]}
            localization={{
              body: {
                emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
                filterRow: {
                  filterTooltip: 'Φίλτρο',
                  filterPlaceHolder: 'Αναζήτηση'
                }
              },
              toolbar: {
                addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
                showColumnsTitle: "Δείξτε κολώνες",
                addTooltip: "Προσθήκη",
                searchTooltip: "Αναζήτηση",
                searchPlaceholder: "Αναζήτηση",
                exportTitle: "Εξαγωγή",
                exportCSVName: "Εξαγωγή σε CSV",
                exportPDFName: "Εξαγωγή σε PDF",
              },

              pagination: {
                firstTooltip: "Πρώτη Σελίδα",
                lastTooltip: "Τελευταία Σελίδα",
                previousTooltip: "Προηγούμενη Σελίδα",
                nextTooltip: "Επόμενη Σελίδα",
                labelDisplayedRows: "{from}-{to} από {count}",
                labelRowsSelect: "Εγγραφές ανά Σελίδα",
              },
              header: {
                actions: "Ενέργειες",
              },
            }}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 20],
              searchFieldAlignment: "left",
              columnsButton: true,
              exportPdf: (columns, data) => {
                exportPDF(columns, data);
              },
              exportCsv: (columns, data) => {
                exportCSV(columns, data);
              },
              exportButton: true,
              grouping: false,
              sorting: true,
              exportAllData: true,
              filtering: true,
              search:false
            }}
          />
        </CardBody>
      </Card>
    </Grid>
  );
}


export default EndUsers;
